<template>
	<div class="input-select" :class="input.class">
		<select v-model="value" :name="input.name">
			<option v-for="(selection,i) in input.selections" :key="i" :value="selection.value" v-text="getSelectionText(selection)"></option>
		</select>
	</div>
</template>

<script>
import InputBase from "./InputBase";
import helper from "@/mixins/helper.js";

export default {
	name: "InputSelect",
	extends: InputBase,
	props: ["option"],
	mixins: [helper],
	data: function() {
		return {
			input: this.option.input,
			value: this.option.input.default
		};
	},
	watch: {
		// Save value to store when changed
		// Save updated Option validation status to store on change
		value: function() {
			this.updateStore();
			this.updateValidationStatus(this.option, this.value);
		}
	},
	created: function() {
		// Save default value to store
		if (this.value) {
			this.updateStore();
		}
		// Save default validation status to store
		this.updateValidationStatus(this.option, this.value);
	},
	computed: {
		selectedOption: function() {
			let self = this;
			return this.input.selections.filter(function(option) {
				return option.value === self.value;
			})[0];
		}
	},
	methods: {
		getSelectionText(selection) {
			return selection.price ? selection.name + " +" + this.formatPrice(selection.price) : selection.name;
		},
		updateStore() {
			this.setSelectedOptionToStore(this.input.name, {
				name: this.option.name + ": " + this.value,
				sku: this.selectedOption.sku,
				position: this.option.position,
				price: this.selectedOption.price,
				value: this.value,
				previewValue: this.selectedOption.previewValue,
				previewMutations: this.option.previewMutations
			});
		}
	}
};
</script>

<style lang="scss">
.input-select {
	select {
		display: inline-block;
		font-size: 1.2em;
		font-family: $font-family;
		font-weight: 400;
		color: $text-color;
		line-height: 1.3;
		padding: 0.6em 1.4em 0.5em 0.8em;
		width: 100%;
		height: 50px;
		max-width: 300px;
		box-sizing: border-box;
		margin: 0;
		border: 1px solid $border-color;
		box-shadow: none;
		border-radius: 0;
		-moz-appearance: none;
		-webkit-appearance: none;
		appearance: none;
		background-color: #fff;
		background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%30364d%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E"),
			linear-gradient(to bottom, #ffffff 0%, #ffffff 100%);
		background-repeat: no-repeat, repeat;
		background-position: right 0.7em top 50%, 0 0;
		background-size: 0.65em auto, 100%;

		&::-ms-expand {
			display: none;
		}
		&:hover {
			border-color: $border-color;
		}
		&:focus {
			border-color: $color-martinique-blue;
			box-shadow: none;
			color: $text-color;
			outline: none;
		}
		option {
			font-weight: normal;
		}
	}
}
</style>